<template>
  <div class="claimsNav">
    <nav class="navbar">
      <div class="nav-left flex">
        <button type="button" class="btn btn-back nav-back" @click="$router.push('/claims')" />
        <div class="nav-item flex flex-column">
          <simple-select
            v-if="claimById"
            class="claim-type-name"
            v-model="claim.claim_type_id"
            :options="claimTypes"
            track-by="id"
            :placeholder="claimById.claim_type.name"
            @input="claimUpdateType"
          />
          <span v-if="claimById"
                class="list-box-status d-flex align-items-start"
                :class="claimStatus"
          >
            {{ claimById.claim_status.name }}
          </span>
        </div>
        <div class="nav-item icon">
          <i class="fa fa-exclamation-circle"
             :class="claimPriority"
             style="font-size:16px;padding-right:6px;"
          />
        </div>
        <div class="nav-item select-prio">
          <simple-select
            v-if="claimById"
            class="nav-select"
            v-model="claim.claim_priority_id"
            :class="claimPriority"
            :options="claimPriorities"
            track-by="id"
            :placeholder="claimById.claim_priority.name"
            @input="claimUpdatePriority"
          />
        </div>
      </div>

      <div class="nav-right flex">
        <div v-if="claimById.job && claimById.job.company && $_can('tags.show')" class="d-flex align-items-center justify-content-end flex-wrap mr-3">
          <tag-color v-for="tag in claimById.job.company.tags" :color="tag.color.name" :name="tag.name" :key="tag.id" input-class="mr-3" />
        </div>
        <button type="button" class="btn btn-secondary nav-item" @click="toggleRefundModal"><i class="fa fa-usd" /> Refund</button>
        <button type="button" class="btn btn-primary nav-item" @click.prevent="claimClose = true">Close claim</button>
      </div>
    </nav>

    <!-- reassignCompany modal -->
    <modal v-if="claimClose" @close="claimClose = false" :size="'modal-large'"
           :close-strict="true"
    >
      <div slot="header">
        <h4>Close claim</h4>
      </div>
      <div slot="body">
        <div class="select-wrap">
          <label>Select a resolution</label>
          <simple-select
            v-if="claimById"
            :options="claimResolutions"
            v-model="claim_resolution_id"
          />
          <!--          v-model="assignedCompanyId"
          :options="companiesWithCoverage"
          placeholder="Select Company"
          @input="clearError($event)"-->
        </div>

        <error-field :errors="errors" field="claim_resolution_id" />

        <div class="select-wrap h-auto mt-3">
          <label>Enter a note</label>
          <textarea class="select-wrap-textarea form-control" rows="5" v-model="note" required />
        </div>
        <error-field :errors="errors" field="note" />
      </div>
      <div slot="footer">
        <div class="row">
          <div class="col-12 text-right">
            <button class="btn btn-secondary" type="button" @click="claimClose = false">Cancel</button>
            <button type="button" class="btn btn-primary" :disabled="buttonDisabled" @click="claimResolution">Close claim</button>
          </div>
        </div>
      </div>
    </modal>

    <!--  Refund modal  -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showRefundModal">
        <transactions-modal
          class="sidebar-right"
          @cancel="toggleRefundModal()"
          :claim="claimById"
          @update="$emit('update')"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import toastr from 'toastr';
import axios from 'axios';
import Modal from '../Modal';
import TransactionsModal from '../transactions/TransactionsModal';
import Errors from '../../classes/Errors';
import TagColor from '../settings/Tags/TagColor';

export default {
  name: 'LayoutTopNav',
  components: {
    TagColor,
    TransactionsModal,
    Modal,
  },
  props: {
    claimById: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    claim: {
      claim_priority_id: '',
      ref_id: '',
      title: '',
      description: '',
      claim_type_id: '',
      cluster_user_id: '',
    },
    claimClose: false,
    note: '',
    claim_resolution_id: '',
    showRefundModal: false,
    errors: new Errors(),
    buttonDisabled: true,
  }),
  computed: {
    ...mapState({
      claimPriorities: state => state.claims.claimPriorities.data,
      claimResolutions: state => state.claims.claimResolutions.data,
      claimTypes: state => state.claims.claimTypes.data,
    }),
    claimStatus() {
      return this.claimById.claim_status.name;
    },
    claimPriority() {
      return this.claimById.claim_priority.name;
    },
  },
  watch: {
    note() {
      this.formValidation();
    },
    claim_resolution_id() {
      this.formValidation();
    },
  },
  created() {
    this.getClaimPriorities();
    this.setClaimData();
    this.getClaimResolutions();
    this.getClaimTypes();
    this.claim.claim_type_id = this.claimById.claim_type.id;
  },
  methods: {
    formValidation() {
      if (this.note === '' || this.claim_resolution_id === '') {
        this.buttonDisabled = true;
      } else {
        this.buttonDisabled = false;
      }
    },
    ...mapActions(['getClaimPriorities', 'getClaimResolutions', 'getClaimTypes']),
    toggleRefundModal() {
      this.showRefundModal = !this.showRefundModal;
    },
    setClaimData() {
      this.claim.claim_priority_id = this.claimById.claim_priority.id;
      this.claim.ref_id = this.claimById.ref_id;
      this.claim.title = this.claimById.title;
      this.claim.description = this.claimById.title;
      this.claim.claim_type_id = this.claimById.claim_type.id;
      this.claim.cluster_user_id = this.claimById.cluster_user_id;
    },
    claimUpdate() {
      axios
        .put(`/claims/${this.$route.params.id}`, this.claim)
        .then(() => {
          toastr.success('Claim updated successfully');
          this.$emit('update', 'claim updated');
        })
        .catch(err => {
          toastr.error(err);
        });
    },
    claimUpdatePriority() {
      axios
        .put(`/claims/${this.$route.params.id}`, {
          claim_priority_id: this.claim.claim_priority_id,
        })
        .then(() => {
          toastr.success('Claim updated successfully');
          this.$emit('update', 'claim updated');
        })
        .catch(err => {
          toastr.error(err);
        });
    },
    claimUpdateType() {
      axios
        .put(`/claims/${this.$route.params.id}`, { claim_type_id: this.claim.claim_type_id })
        .then(() => {
          toastr.success('Claim updated successfully');
          this.$emit('update', 'claim updated');
        })
        .catch(err => {
          toastr.error(err);
        });
    },
    claimResolution() {
      axios
        .put(`/claims/${this.$route.params.id}/close`, {
          note: this.note,
          claim_resolution_id: this.claim_resolution_id,
        })
        .then(() => {
          toastr.success('Claim updated successfully');
          this.$emit('update', 'claim updated');
          this.claimClose = false;
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
  },
};
</script>
<style lang="scss">
nav.navbar {
  height: 62px;
  background-color: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.07);
  width: 100%;
}

.nav-back {
  margin: 0 0 0 5px;
}

.nav-left,
.nav-right {
  align-items: center;
}

.nav-left .nav-item {
  margin: 0 12px 0 15px;
}
.nav-item.icon {
  margin-right: 0 !important;
}
.nav-item.select-prio {
  margin-left: 0 !important;
}
.nav-right .nav-item {
  margin: 0 8px 0 8px;
}

.nav-select {
  background: transparent;
  border: none;
  width: 120px;
}

.claim-type {
  font-size: 20px;
  line-height: 24px;
  color: #000;
}

.list-box-status {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
}

.nav-item.select-prio:hover {
  background: #f4f5f7;
}

/* related to computed properties - Claim status and claim priority */
.New {
  color: #f56722;
}

.Active {
  color: #2962ff;
}

.Closed {
  color: #3db152;
}

.Reopened {
  color: #2962ff;
}

.Low ::placeholder,
.Low {
  color: #2db300;
}

.Medium ::placeholder,
.Medium {
  color: #ffab00;
}

.High ::placeholder,
.High {
  color: #ed4044;
}
.claim-type-name {
  & .simple-select-header {
    text-align: left;
  }
}
.claim-type-name {
  & .simple-select-header > input {
    font-size: 20px;
    color: #000;
    padding-left: 0;
  }
}
/* responsive */
@media only screen and (max-width: 414px) {
  nav.navbar {
    height: auto;
    flex-direction: row-reverse;
  }

  .nav-right .nav-item {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/claims/LayoutTopNav.vue